import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { PagerComponent} from '../paginator/pager.component';
import { ComparacaoDadosPessoaisComponent } from './comparacao-dados-pessoais.component';
import { ComparacaoGrupoComponent } from './comparacao-grupo.component';
import { ComparacaoButtonComponent } from './comparacao-button.component';
import { QuestionarioDinamicoModule } from 'unb-questionario-componente';
import { ComparacaoComponent } from './comparacao.component';
import { GrupoFamiliarModule } from '../grupo-familiar/grupo-familiar.module';

/** AngularMaterial **/
import { MatSelectModule, MatButtonModule, MatIconModule, MatInputModule, MatToolbarModule,
  MatProgressBarModule, MatSnackBarModule, MatTabsModule, MatDialogModule,
   MatListModule, MatCardModule, MatExpansionModule, MatChipsModule } from '@angular/material';
import { ComparacaoDialog } from './comparacao.dialog';
import { EstudoListSelectionModule } from '../estudo-list/estudo-list-selection.module';



@NgModule({
    declarations: [
      ComparacaoComponent, ComparacaoDadosPessoaisComponent, ComparacaoGrupoComponent, ComparacaoButtonComponent, ComparacaoDialog
    ],
    exports: [
      ComparacaoComponent, ComparacaoDadosPessoaisComponent, ComparacaoGrupoComponent, ComparacaoButtonComponent, ComparacaoDialog
    ],
    imports: [
      FormsModule, CommonModule, QuestionarioDinamicoModule, GrupoFamiliarModule, EstudoListSelectionModule,
      MatSelectModule, MatButtonModule, MatIconModule, MatInputModule, MatProgressBarModule, MatSnackBarModule,
      MatDialogModule, MatCardModule, MatListModule, MatToolbarModule, MatTabsModule, MatExpansionModule, MatChipsModule
    ],
    providers: [
      PagerComponent
    ]
})
export class ComparacaoModule {

}
